export default __webpack_public_path__ + "static/media/tour-e-agency-small.2d48374a.png";